
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#464646","d":"M17.087 11.375H6.912A2.496 2.496 0 004.5 9.5a2.5 2.5 0 000 5 2.496 2.496 0 002.412-1.875h10.175A2.496 2.496 0 0019.5 14.5a2.5 2.5 0 000-5 2.496 2.496 0 00-2.413 1.875z"}})])])
          )
        }
      }
    